'use client';

import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { type PropsWithChildren, useEffect, useRef } from 'react';

import { RoutingContext } from '@/contexts/routingContext';

export const RoutingProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastPageRef = useRef<{ pathname: string; search: string } | null>(null);
  const previousPathname = useRef<string | null>(null);

  useEffect(() => {
    if (previousPathname.current && previousPathname.current !== pathname) {
      lastPageRef.current = {
        pathname: previousPathname.current,
        search: searchParams.toString(),
      };
    }

    previousPathname.current = pathname;
  }, [pathname, searchParams]);

  const back = () => {
    if (lastPageRef.current) {
      router.push(
        lastPageRef.current.pathname +
          (lastPageRef.current.search ? `?${lastPageRef.current.search}` : '')
      );
    } else {
      history.back();
    }
  };

  const isLastPageAvailable = () => {
    return !!lastPageRef.current;
  };

  return (
    <RoutingContext.Provider
      value={{
        back,
        canGoBack: isLastPageAvailable,
      }}
    >
      {children}
    </RoutingContext.Provider>
  );
};
